module.exports = __webpack_public_path__ + "img/1.0090cf01.jpg";